import React, { useState } from 'react';
import './StoryCreate.css';
import StoryAiCreator from './StoryAiCreator';

const StoryCreate = () => {
    const [showOptions, setShowOptions] = useState(false);
    const [currentView, setCurrentView] = useState('main'); // 'main', 'content-types', 'options', 'ai-creator', 'storyboard'
    const [selectedContentType, setSelectedContentType] = useState(null);

    const handleCreateContent = () => {
        setCurrentView('content-types');
    };

    const handleContentTypeSelect = (contentType) => {
        setSelectedContentType(contentType);
        setShowOptions(true);
        setCurrentView('options');
    };

    const handleOptionSelect = (option) => {
        console.log(`Selected option: ${option} for content type: ${selectedContentType}`);
        if (option === 'ai-create') {
            setCurrentView('ai-creator');
        } else if (option === 'storyboard') {
            setCurrentView('storyboard');
        }
    };

    const handleBack = () => {
        setShowOptions(false);
        setCurrentView('main');
        setSelectedContentType(null);
    };

    const handleBackToContentTypes = () => {
        setCurrentView('content-types');
        setShowOptions(false);
    };

    const handleBackToOptions = () => {
        setCurrentView('options');
    };

    // Render AI Creator
    if (currentView === 'ai-creator') {
        return <StoryAiCreator onBack={handleBackToOptions} contentType={selectedContentType} />;
    }

    // Render Storyboard Creator (placeholder)
    if (currentView === 'storyboard') {
        return (
            <div className="story-create-container">
                <div className="story-create-options-header">
                    <button 
                        className="story-create-back-button"
                        onClick={handleBackToOptions}
                    >
                        ← Back
                    </button>
                    <h2 className="story-create-options-title">Storyboard Creator</h2>
                </div>
                <div className="story-menu-placeholder">Storyboard Creator coming soon...</div>
            </div>
        );
    }

    // Render Content Type Selection
    if (currentView === 'content-types') {
        const contentTypes = [
            { id: 'short-film', name: 'Short Film', icon: '🎬', description: 'Create compelling short films with full narrative structure' },
            { id: 'reel', name: 'Instagram Reel', icon: '📱', description: 'Quick, engaging vertical videos for social media' },
            { id: 'story', name: 'Instagram Story', icon: '📸', description: '15-second visual stories that disappear after 24 hours' },
            { id: 'tiktok', name: 'TikTok Video', icon: '🎵', description: 'Trendy, music-driven short-form content' },
            { id: 'youtube-short', name: 'YouTube Short', icon: '▶️', description: 'Vertical videos up to 60 seconds for YouTube' },
            { id: 'vsl', name: 'Video Sales Letter', icon: '🎯', description: 'Direct-response sales videos to convert viewers into customers' },
            { id: 'youtube-tutorial', name: 'YouTube Tutorial', icon: '🎓', description: 'Educational step-by-step instructional videos' },
            { id: 'youtube-framework', name: 'YouTube Framework', icon: '📋', description: 'Structured educational content with clear systems and processes' },
            { id: 'youtube-vlog', name: 'YouTube Vlog', icon: '📹', description: 'Personal lifestyle and behind-the-scenes content' },
            { id: 'linkedin-video', name: 'LinkedIn Video', icon: '💼', description: 'Professional content for business networking and thought leadership' },
            { id: 'ad', name: 'Advertisement', icon: '📺', description: 'Commercial content to promote products or services' }
        ];

        return (
            <div className="story-create-container">
                <div className="story-create-options-header">
                    <button 
                        className="story-create-back-button"
                        onClick={handleBack}
                    >
                        ← Back
                    </button>
                    <h2 className="story-create-options-title">Choose Content Type</h2>
                </div>
                
                <div className="story-create-content-types-grid">
                    {contentTypes.map((type) => (
                        <div 
                            key={type.id} 
                            className="story-create-content-type-card"
                            onClick={() => handleContentTypeSelect(type)}
                        >
                            <div className="story-create-content-type-icon">{type.icon}</div>
                            <h3 className="story-create-content-type-title">{type.name}</h3>
                            <p className="story-create-content-type-description">{type.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="story-create-container">
            {currentView === 'main' ? (
                <div className="story-create-main">
                    <div className="story-create-hero">
                        <h2 className="story-create-title">Create Your Content</h2>
                        <p className="story-create-subtitle">
                            Transform your ideas into compelling visual content for any platform
                        </p>
                        
                        <button 
                            className="story-create-main-button"
                            onClick={handleCreateContent}
                        >
                            <span className="story-create-button-icon">✨</span>
                            Start Creating
                        </button>
                    </div>
                </div>
            ) : (
                <div className="story-create-options">
                    <div className="story-create-options-header">
                        <button 
                            className="story-create-back-button"
                            onClick={handleBackToContentTypes}
                        >
                            ← Back
                        </button>
                        <h2 className="story-create-options-title">
                            Create {selectedContentType?.name || 'Content'}
                        </h2>
                    </div>
                    
                    <div className="story-create-options-grid">
                        <div 
                            className="story-create-option-card"
                            onClick={() => handleOptionSelect('storyboard')}
                        >
                            <div className="story-create-option-icon">📝</div>
                            <h3 className="story-create-option-title">Write Storyboard</h3>
                            <p className="story-create-option-description">
                                Create your own storyboard from scratch with full creative control
                            </p>
                        </div>
                        
                        <div 
                            className="story-create-option-card"
                            onClick={() => handleOptionSelect('ai-create')}
                        >
                            <div className="story-create-option-icon">🤖</div>
                            <h3 className="story-create-option-title">Let AI Create Stories</h3>
                            <p className="story-create-option-description">
                                Generate unique stories using artificial intelligence
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default StoryCreate; 